import React from "react";
import InvoicePO from "./InvoicePO";
import {useUtilData} from "../../hooks/useUtilData";
import Nav from "../Nav/Nav";


export default function InvoicePOView(props){
    const utilsLoaded = useUtilData({work_type: 1, payment_type: 1, nominal: 1, tracking: 1, department: 1});

    return (
        <div>
            <Nav/>
            <InvoicePO loaded={utilsLoaded} {...props}/>
        </div>
    )

}